<p>user-validate-account works!</p>
